import { render, staticRenderFns } from "./WaChartPanel.vue?vue&type=template&id=e4b6cba4"
import script from "./WaChartPanel.vue?vue&type=script&lang=js"
export * from "./WaChartPanel.vue?vue&type=script&lang=js"
import style0 from "./WaChartPanel.vue?vue&type=style&index=0&id=e4b6cba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports